export default __webpack_public_path__ + "static/media/gallery-wip-emitter_09.6f73da7d.jpg";